import axios from 'axios'
import FeedImportMappingsService from '@frontend/services/api/feed-import-mappings'

export default {
  namespaced: true,

  state: () => ({
    options: [],
    currentOption: null,
    loading: false,
    error: null
  }),

  getters: {
    options: state => state.options,
    currentOption: state => state.currentOption,
    loading: state => state.loading,
    error: state => state.error
  },

  mutations: {
    SET_OPTIONS(state, payload) {
      state.options = payload
    },
    SET_CURRENT_OPTION(state, payload) {
      state.currentOption = payload
    },
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },

  actions: {
    async fetchSimpleOptions({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const { data } = await FeedImportMappingsService.simpleList()
        commit('SET_OPTIONS', data)
        return data
      } catch (error) {
        commit('SET_ERROR', error.message || 'Failed to fetch settings')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
}
